import React from 'react';
import { Info } from 'react-feather';
import moment from 'moment';
import { Text, TEXT_VARIANTS } from 'ui/Typography';

const getErrorMessageFromCode = (code, options = {}) => {
  const errorCodes = {
    'zoom.external_api_error': t(
      'in_person_training.errors.zoom.external_api_error',
    ),
    'zoom.external_authentication_error': t(
      'in_person_training.errors.zoom.external_authentication_error',
    ),
    'zoom.external_rate_limit_exceeded': t(
      'in_person_training.errors.zoom.external_rate_limit_exceeded',
    ),
    'zoom.external_rate_limit_exceeded_retry_after': t(
      'in_person_training.errors.zoom.external_rate_limit_exceeded_retry_after',
      options,
    ),
    'zoom.external_resource_not_found': t(
      'in_person_training.errors.zoom.external_resource_not_found',
    ),
  };
  return errorCodes[code];
};

const getErrorMessage = error => {
  const { message, code, service, retryAfter, responseJSON } = error;
  const returnedJSONMessage = responseJSON && responseJSON.message;
  const defaultMessage =
    message || returnedJSONMessage || t('common.oops_notify_error');

  if (!code || !service) {
    return defaultMessage;
  }

  let translation = null;
  if (retryAfter) {
    translation = getErrorMessageFromCode(`${service}.${code}_retry_after`, {
      retryAfter: moment(retryAfter).format('LLLL'),
    });
  } else {
    translation = getErrorMessageFromCode(`${service}.${code}`);
  }
  return translation || defaultMessage;
};

const Error = error => (
  <div className="d-f fd-r ai-fs mb-8 mt-24">
    <Info className="mr-8 llui-text-instrux-error is-16" size={17} />
    <Text variant={TEXT_VARIANTS.INSTRUX_ERROR}>{getErrorMessage(error)}</Text>
  </div>
);

export default Error;
export { getErrorMessage };
